import { ReactComponent as InfoIcon } from "../../../../assets/svg/icons/info.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/svg/icons/archive.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/svg/icons/trashOnboarding.svg";
import { useEditOnboarding } from "../../../../hooks/useEditOnboarding";
import { useTaskCreation } from "../../../../hooks/useTaskCreation";
import "./styles.css";

type TableVisualizationRowProps = {
  evaluation: IMicroAreaEvaluation;
  setSelectedId: (e: number) => void;
};

export default function TableEvaluationRow({
  evaluation,
  setSelectedId
}: TableVisualizationRowProps) {

  const created = new Date(evaluation?.created_at)
  const updated = new Date(evaluation?.updated_at)

  const statusMap = new Map<string, string>()
  statusMap.set("COMPLETED", "Avaliado")
  statusMap.set("PENDING", "Pendente")
  statusMap.set("CANCELED", "Cancelada")
  statusMap.set("ARCHIVE", "Arquivado")

  const {
    setIdSelected
  } = useEditOnboarding();

  const {
    setModalArchiveEvaluation,
    setModalCancelateEvaluation,
    setTaskId
  } = useTaskCreation();

  return (
    <div className="tableRowEvaluation">
      <div>{evaluation.evaluator}</div>
      <div>{evaluation.micro_area_initials}</div>
      <div>{statusMap.get(evaluation.status)}</div>
      <div>
        {evaluation?.created_at ?
          <>
            {`${String(created.getDate()).padStart(2, "0")}/${String(created.getMonth() + 1).padStart(2, "0")}/${String(created.getFullYear() % 100).padStart(2, "0")}`}
            < br />
            {`${String(created.getHours()).padStart(2, "0")}:${String(created.getMinutes()).padStart(2, "0")}`}
          </> :
          ""}
      </div>
      <div>
        {evaluation?.updated_at ?
          <>
            {`${String(updated.getDate()).padStart(2, "0")}/${String(updated.getMonth() + 1).padStart(2, "0")}/${String(updated.getFullYear() % 100).padStart(2, "0")}`}
            < br />
            {`${String(updated.getHours()).padStart(2, "0")}:${String(updated.getMinutes()).padStart(2, "0")}`}
          </>
          :
          ""}
      </div>
      <div className="infoButton">
        <button title="Ver detalhes" style={{
          display: (evaluation.status == "ARCHIVE" || evaluation.status == "COMPLETED") ? "block" : "none",
          backgroundColor: "transparent"
        }}>
          <InfoIcon
            onClick={() => {
              setSelectedId(evaluation.task_id)
              setIdSelected(evaluation.micro_area_id)
            }}
          />
        </button>
        <button title="Arquivar" style={{
          display: (evaluation.status == "ARCHIVE" || evaluation.status != "COMPLETED") ? "none" : "block", fill: "rgb(77, 77, 77)",
          backgroundColor: "transparent"
        }}>
          <ArchiveIcon
            onClick={() => {
              setTaskId(evaluation.task_id)
              setModalArchiveEvaluation(true)
            }}
          />
        </button>
        <button title="Deletar" style={{
          display: (evaluation.status == "COMPLETED" || evaluation.status == "ARCHIVE" || evaluation.status == "CANCELED") ? "none" : "block",
          backgroundColor: "transparent"
        }}>
          <DeleteIcon
            onClick={() => {
              setTaskId(evaluation.task_id)
              setModalCancelateEvaluation(true)
            }}
          />
        </button>
      </div>
    </div>
  );
}
